import * as ActionTypes from "../ActionTypes";
import axios from "../../Utils/http";
export function getRequest(API_URL, Success_Action, body) {
  return async (dispatch) => {
    const spin = await dispatch({
      type: ActionTypes.SET_SPINNER,
      payload: true,
    });

    if (spin) {
      return axios
        .get(API_URL, body)
        .then((response) => {
          dispatch({ type: ActionTypes.SET_SPINNER, payload: false });
          if (response.status === 200) {
            dispatch({ type: Success_Action, payload: response.data });
            return response.data;
          } else {
            dispatch({ type: Success_Action, payload: [] });
          }
          return response.data;
        })

        .catch((error) => {
          dispatch({ type: ActionTypes.SET_SPINNER, payload: false });
          if (error.response && error.response.data) {
            return error.response.data;
          }
        });
    }
    return "success";
  };
}

export function postRequest(API_URL, body, Success_Action, exParam) {
  return async (dispatch) => {
    const spin = await dispatch({
      type: ActionTypes.SET_SPINNER,
      payload: true,
    });
    
    if (spin) {
      return axios
        .post(API_URL, body)
        .then((response) => {
          if (response.status === 200) {
            if (Success_Action == "SUBMIT_FORM") {
              dispatch({
                type: Success_Action,
                payload: response.data,
                body: body,
                value: body,
                exParam:exParam?exParam:{},
              });
            }  else if (Success_Action === "SET_EVENTDATA") {
              dispatch({
                type: Success_Action,
                payload:body,
              });
            }
            else {
              dispatch({
                type: Success_Action,
                payload: response.data,
                exParam:exParam?exParam:{},
              });
            }
          } else {
            dispatch({ type: Success_Action, payload: {} });
          }
          dispatch({ type: ActionTypes.SET_SPINNER, payload: false });
          return response.data;
        })

        .catch((error) => {
          error.response &&
            error.response.data &&
            dispatch({ type: ActionTypes.SET_SPINNER, payload: false });
            if(Success_Action==="ASSIGN_PROSPECT"){
              dispatch({ type: ActionTypes.ASSIGN_PROSPECT, payload: error.response.data });
            }
          return error.response;
        });
    }
    return "success";
  };
}

export function fetchcampaign(API_URL, body, Success_Action,customerId) {
  return async (dispatch) => {
    const spin = await dispatch({
      type: ActionTypes.SET_SPINNER,
      payload: true,
    });

    if (spin) {
      return axios
        .post(API_URL, body,{
          headers:{
            "X-CUSTOMER-ID":customerId
          }
        })
        .then((response) => {
          if (response.status === 200) {
            if (Success_Action == "CAMPAIGN_LIST") {
              dispatch({
                type: Success_Action,
                payload: response.data,
                body: body,
              });
            }  
          } 
          dispatch({ type: ActionTypes.SET_SPINNER, payload: false });
          return response.data;
        })

        .catch((error) => {
          error.response &&
            error.response.data &&
            dispatch({ type: ActionTypes.SET_SPINNER, payload: false });
          return error.response;
        });
    }
    return "success";
  };
}


export function getRequest1(API_URL, Success_Action, custId, emailId) {
  return async (dispatch) => {
    const spin = await dispatch({
      type: ActionTypes.SET_SPINNER,
      payload: true,
    });

    if (spin) {
      return axios
        .get(API_URL, {
          headers: {
            "X-CUSTOMER-ID": custId,
            "X-EMAIL-ID": emailId,
          },
        })
        .then((response) => {
          dispatch({ type: ActionTypes.SET_SPINNER, payload: false });
          if (response.status === 200) {
            dispatch({ type: Success_Action, payload: response.data });
            return response.data;
          } else {
            dispatch({ type: Success_Action, payload: [] });
          }
          return response.data;
        })

        .catch((error) => {
          dispatch({ type: ActionTypes.SET_SPINNER, payload: false });
          if (error.response && error.response.data) {
            return error.response.data;
          }
        });
    }
    return "success";
  };
}
export function getRequest2(API_URL, Success_Action,custId) {
  return async (dispatch) => {
    const spin = await dispatch({
      type: ActionTypes.SET_SPINNER,
      payload: true,
    });

    if (spin) {
      return axios
        .get(API_URL, {
          headers: {
            "X-CUSTOMER-ID": custId,
          },
        })
        .then((response) => {
          dispatch({ type: ActionTypes.SET_SPINNER, payload: false });
          if (response.status === 200) {
            dispatch({ type: Success_Action, payload: response.data });
            return response.data;
          } else {
            dispatch({ type: Success_Action, payload: [] });
          }
          return response.data;
        })

        .catch((error) => {
          dispatch({ type: ActionTypes.SET_SPINNER, payload: false });
          if (error.response && error.response.data) {
            return error.response.data;
          }
        });
    }
    return "success";
  };
}
export function postRequest1(API_URL, body, Success_Action, custId, emailId,agentId,agencyId,userId) {
  return async (dispatch) => {
    const spin = await dispatch({
      type: ActionTypes.SET_SPINNER,
      payload: true,
    });

    if (spin) {
      return axios
        .post(API_URL, body, {
          headers: {
             "Content-Type":
              Success_Action === "PROSPECT_FILE_UPLOAD" ||
              Success_Action === "CAMPAIGN_FILE_UPLOAD"
                ? "multipart/form-data"
                : "application/json",
            "X-CUSTOMER-ID": custId,
            "X-EMAIL-ID": emailId,
            "X-AGENT-ID":agentId,
            "X-AGENCY-ID":agencyId,
            "X-USER-ID":userId??""
          },
        })
        .then((response) => {
          if (response.status === 200) {
            if (Success_Action == "SUBMIT_FORM") {
              dispatch({
                type: Success_Action,
                payload: response.data,
                body: body,
                value: body,
              });
            } else {
              dispatch({
                type: Success_Action,
                payload: response.data,
                body: body,
              });
            }
          } else {
            dispatch({ type: Success_Action, payload: {} });
          }
          dispatch({ type: ActionTypes.SET_SPINNER, payload: false });
          return response.data;
        })

        .catch((error) => {
          error.response &&
            error.response.data &&
            dispatch({ type: ActionTypes.SET_SPINNER, payload: false });
          return error.response;
        });
    }
    return "success";
  };
}

export function postRequest2(API_URL, body, Success_Action, username, pwd,custId) {
  return async (dispatch) => {
    const spin = await dispatch({
      type: ActionTypes.SET_SPINNER,
      payload: true,
    });

    if (spin) {
      return axios
        .post(API_URL, body, {
          headers: {
            Authentication: window.btoa(username + "/" + pwd),
            "X-CUSTOMER-ID": custId,
          },
        })
        .then((response) => {
          if (response.status === 200) {
            if (Success_Action == "SUBMIT_FORM") {
              dispatch({
                type: Success_Action,
                payload: response.data,
                body: body,
                value: body,
              });
            } else {
              dispatch({
                type: Success_Action,
                payload: response.data,
                body: body,
              });
            }
          } else {
            dispatch({ type: Success_Action, payload: {} });
          }
          dispatch({ type: ActionTypes.SET_SPINNER, payload: false });
          return response.data;
        })

        .catch((error) => {
          error.response &&
            error.response.data &&
            dispatch({ type: ActionTypes.SET_SPINNER, payload: false });
          return error.response;
        });
    }
    return "success";
  };
}
export function uploadPostRequest(API_URL, body, Success_Action, success_extraData) {
  return async (dispatch) => {
    const spin = await dispatch({
      type: ActionTypes.SET_SPINNER,
      payload: true,
    });

    if (spin) {
    const headers = {
      headers: {
        "content-type": "multipart/form-data",
      },
    };
    return axios
      .post(API_URL, body, headers)
      .then((response) => {
        if (response.status === 200) {
          dispatch({
            type: Success_Action,
            payload: Success_Action === ActionTypes.UPLOAD_FILES ? success_extraData : response,
          });
          dispatch({ type: ActionTypes.SET_SPINNER, payload: false });
          return response.data;
        } else {
          dispatch({
            type: Success_Action,
            payload: [],
          });
        }
        dispatch({ type: ActionTypes.SET_SPINNER, payload: false });
        return response.data;
      })

      .catch((error) => {
        dispatch({ type: ActionTypes.SET_SPINNER, payload: false });
        dispatch({
          type: Success_Action,
          payload: [],
        });
        return error.response;
      });
  }
  }
}
export function postRequest3(API_URL, body, Success_Action,token) {
  return async (dispatch) => {
    const spin = await dispatch({
      type: ActionTypes.SET_SPINNER,
      payload: true,
    });

    if (spin) {
      return axios
        .post(API_URL, body, {
          headers: {
            "Authorization": token,
          },
        })
        .then((response) => {
          if (response.status === 200) {
            if (Success_Action == "SUBMIT_FORM") {
              dispatch({
                type: Success_Action,
                payload: response.data,
                body: body,
                value: body,
              });
            } else {
              dispatch({
                type: Success_Action,
                payload: response.data,
                body: body,
              });
            }
          } else {
            dispatch({ type: Success_Action, payload: {} });
          }
          dispatch({ type: ActionTypes.SET_SPINNER, payload: false });
          return response.data;
        })

        .catch((error) => {
          error.response &&
            error.response.data &&
            dispatch({ type: ActionTypes.SET_SPINNER, payload: false });
          return error.response;
        });
    }
    return "success";
  };
}
export function guestLoginReq(API_URL, Success_Action, body) {
  return async (dispatch) => {
    const spin = await dispatch({
      type: ActionTypes.SET_SPINNER,
      payload: true,
    });

    if (spin) {
      return axios
        .get(API_URL,
          {
            headers: {
              Authentication: window.btoa(body),
            },
          })
        .then((response) => {
          dispatch({ type: ActionTypes.SET_SPINNER, payload: false });
          if (response.status === 200) {
            dispatch({ type: Success_Action, payload: response.data });
            return response.data;
          } else {
            dispatch({ type: Success_Action, payload: [] });
          }
          return response.data;
        })

        .catch((error) => {
          dispatch({ type: ActionTypes.SET_SPINNER, payload: false });
          if (error.response && error.response.data) {
            return error.response.data;
          }
        });
    }
    return "success";
  };
}
export function postRequest4(API_URL, body, Success_Action, exParam,custId) {
  return async (dispatch) => {
    const spin = await dispatch({
      type: ActionTypes.SET_SPINNER,
      payload: true,
    });

    if (spin) {
      return axios
        .post(API_URL, body,{
          headers:{
            "X-CUSTOMER-ID":custId
          }
        })
        .then((response) => {
          if (response.status === 200) {
            if (Success_Action == "SUBMIT_FORM") {
              dispatch({
                type: Success_Action,
                payload: response.data,
                body: body,
                value: body,
                exParam:exParam?exParam:{},
              });
            } else {
              dispatch({
                type: Success_Action,
                payload: response.data,
                exParam:exParam?exParam:{},
              });
            }
          } else {
            dispatch({ type: Success_Action, payload: {} });
          }
          dispatch({ type: ActionTypes.SET_SPINNER, payload: false });
          return response.data;
        })

        .catch((error) => {
          error.response &&
            error.response.data &&
            dispatch({ type: ActionTypes.SET_SPINNER, payload: false });
          return error.response;
        });
    }
    return "success";
  };
}
